import * as React from 'react';
import { TextArea, Util } from '@grandvisionhq/forms';

const CancelAppointmentReasonTextarea = ({ label , errorValidation  })=>/*#__PURE__*/ React.createElement(TextArea, {
        name: "otherCancellationReason",
        className: "cancel-appointment-reason-textarea",
        label: label,
        maxLength: 255,
        errorMessage: errorValidation,
        validations: [
            Util.validations.maxLength(255)
        ]
    })
;

export { CancelAppointmentReasonTextarea };
//# sourceMappingURL=CancelAppointmentReasonTextarea.js.map
